import type { DerivedLevel } from './deriveGuide';
import { flattenLevelRows } from './guideFormat';
import WidgetStepRow from './WidgetStepRow';

type Props = {
  level: DerivedLevel;
  environmentId: string;
  onSkipAll: () => void;
  onSkipStep: (code: string) => void;
};

const GuidePanelBody = ({ level, environmentId, onSkipAll, onSkipStep }: Props) => (
  <div className="px-4 pb-4">
    <div className="d-flex justify-content-center my-3">
      <span
        className="d-flex align-items-center justify-content-center rounded bg-primary"
        style={{ width: 44, height: 44 }}
      >
        <i className="ki-duotone ki-rocket fs-2 text-white">
          <span className="path1" />
          <span className="path2" />
        </i>
      </span>
    </div>

    <h4 className="fw-bold text-gray-900 text-center mb-1">{level.title}</h4>
    <div className="text-gray-500 fs-7 text-center mb-4">
      {level.completedSteps} de {level.totalSteps} passos concluídos
    </div>

    <div className="d-flex align-items-center justify-content-between mb-3">
      <span className="badge badge-light-warning fw-bold">{level.progressPercentage}% concluído</span>
      <button type="button" className="btn btn-link btn-sm text-gray-500 p-0" onClick={onSkipAll}>
        Pular tudo
      </button>
    </div>

    <div>
      {flattenLevelRows(level).map((row) => (
        <div key={row.step.code}>
          {!!row.groupTitle && (
            <div className="text-uppercase fw-bold text-gray-400 fs-8 ls-1 mt-3 mb-1 ms-2">{row.groupTitle}</div>
          )}
          <WidgetStepRow step={row.step} environmentId={environmentId} levelLocked={level.locked} onSkip={onSkipStep} />
        </div>
      ))}
    </div>
  </div>
);

export default GuidePanelBody;
